import React from 'react';
import ReactDOM from 'react-dom/client';
import List from './List.js';
import './App.css';

(()=>{
	if(document.getElementById('ms-guestbook')===null){
		return;
	}
	const root=ReactDOM.createRoot(document.getElementById('ms-guestbook'));
	root.render(<List />);
})();
